import React from "react";

const HeroSection: React.FC = () => {
  return (
    <section className="bg-blue-700 text-white py-20 px-6 text-center">
      <h1 className="text-4xl md:text-6xl font-bold mb-4">Welcome to Tadwiro</h1>
      <p className="text-lg md:text-xl mb-6">
        Built by <strong>Ayser World</strong> to transform the construction industry
        with smart, scalable, cloud-native tools.
      </p>
      <a
        href="/about"
        className="bg-white text-blue-700 px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition"
      >
        Learn More
      </a>
    </section>
  );
};

export default HeroSection;